// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/value-sets/alopex-ethnicities.json
export const URL = 'http://alopexcare.com/fhir/ValueSet/alopex-ethnicities';
export const concepts = [
    { code: '2135-2', display: 'Hispanic or Latino', displayUi: 'Hispanic or Latino', system: 'urn:oid:2.16.840.1.113883.6.238' },
    { code: '2186-5', display: 'Not Hispanic or Latino', displayUi: 'Not Hispanic or Latino', system: 'urn:oid:2.16.840.1.113883.6.238' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
